import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

/**
 * sealy GenericPage body assembly (#33585). The GenericPage StreamField is
 * EXACTLY the ``Toolbox``, so the shared map dispatches every key.
 *
 * WRAPPER PARITY (load-bearing): the legacy ``cms/generic_page.html``
 * rendered ``{% include_block self.body %}`` -- the WHOLE StreamField -- so
 * Wagtail's ``StreamBlock.render_basic`` wrapped every top-level block in
 * ``<div class="w-block-{type} block-{type}">``. The sealy block SCSS targets
 * those wrappers (e.g. ``.block-gallery_block`` / ``.block-ugc_grid``), so
 * one wrapper per top-level block is reproduced here, classes verbatim
 * (contrast the Home/Information assemblies, whose legacy templates used a
 * bare ``{% for %}{% include_block %}`` loop and therefore render
 * ``React.Fragment``).
 */
export const GenericPageBody = (
    props: Immutable<{ page: templates.GenericPageTemplate["page"] }>,
): React.JSX.Element | null => {
    // `body` is nullable (`null=True` on the model field).
    if (!props.page.body) {
        return null;
    }
    return (
        <>
            {props.page.body.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{
                        className: `w-block-${block.type} block-${block.type}`,
                    }}
                    value={[block]}
                    components={toolboxComponentsMap}
                />
            ))}
        </>
    );
};
